import React from "react";
import { motion } from "framer-motion";

export default function Side({ setTab, tab }) {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        exit={{ opacity: 0, y: 10 }}
        className="layoutSide"
      >
        <div
          className={"layoutSide__btn " + (tab === "basic" ? "active" : "")}
          onClick={() => setTab("basic")}
        >
          Basics
        </div>
        <div
          className={"layoutSide__btn " + (tab === "more" ? "active" : "")}
          onClick={() => setTab("more")}
        >
          Invoice Preview
        </div>
      </motion.div>
    </>
  );
}
